import React from "react";
import {useLazyQuery, useMutation, useSubscription} from "@apollo/client";
import {QUERY_USERS, USER_WALLET_DATA} from "../registryComponentsGQL.js";
import {Box, Button, FormField, Layer, Text} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {
    GET_WALLET,
    QUERY_PACKAGE,
    QUERY_SERVICES,
    QUERY_USER_PACKAGE_LIST,
    UPSERT_MOVEMENT_WALLET,
    UPSERT_USER_PACKAGE
} from "./UserGQL.js";
import moment from "moment/moment.js";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {extractIdFormData} from "../../../utilis/utils.js";

function LayerMovementWallet(props){
    const [servicesList,setServiceslist]=React.useState([]);
    const [packagesList,setPackageslist]=React.useState([]);
    const [formData,setFormData]=React.useState({wallet:props?.wallet});
    const [upsertMovementWallet] = useMutation(UPSERT_MOVEMENT_WALLET);

    const [ queryServices
    ]  = useLazyQuery(QUERY_SERVICES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            if(data["clubmate_clubmateservice_clubmateservice"]){
                setServiceslist(data["clubmate_clubmateservice_clubmateservice"]);
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });
    const [ queryPacakges
    ]  = useLazyQuery(QUERY_PACKAGE, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            if(data["clubmate_clubmatepackage_clubmatepackage"]){
                setPackageslist(data?.clubmate_clubmatepackage_clubmatepackage);
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });


    React.useEffect(()=>{
        queryServices();
        queryPacakges();
    },[])


    function handleChange(event){
        setFormData({...formData,[event.target.name]:parseFloat(event.target.value)})
    }

    function handleSubmit(){
        let formDataApp=extractIdFormData(formData,false,true)
        upsertMovementWallet(formDataApp)
            .then(data=>{
                alert("Movimento aggiunto!");
                if(props?.getData){
                    props?.getData();
                    props?.onEscLayer();
                }

            })
            .catch(error=>{console.error("errore",error)})
    }

    React.useEffect(()=>{
        console.log("FORMDATA",formData);
    },[formData])

    return (
        <Layer onEsc={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box margin={"medium"} gap={"medium"} overflow="auto"  height="450px" width="500px" alignSelf='center' style={{marginTop:'40px'}}>
                <Text weight={"bold"}>Aggiungi movimento di portafoglio(€)</Text>
                <FormField style={{marginTop:'40px'}} >
                    <TextField type="number" label="Quantità*" name="quantity" onChange={handleChange}/>
                </FormField>

                    <Autocomplete
                        disablePortal
                        id="service"
                        name={"service"}
                        value={formData?.service}
                        getOptionKey={(option) => option?.id}
                        getOptionLabel={(option) => option?.name}
                        options={servicesList}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Servizi" />}
                        onChange={(event, value) => setFormData({...formData,"service":value})}
                    />

                    <Autocomplete
                        disablePortal
                        id="package"
                        name={"package"}
                        value={formData?.package}
                        getOptionKey={(option) => option?.id}
                        getOptionLabel={(option) => option?.name}
                        options={packagesList}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Pacchetti" />}
                        onChange={(event, value) => setFormData({...formData,"package":value})}
                    />

                <Button alignSelf={"end"} label={"Aggiungi movimento"} onClick={handleSubmit} style={{width:'180px',height:'34px',fontSize:'13px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
            </Box>
        </Layer>
    )
}

export default LayerMovementWallet;